__turbopack_context__.v({
  "bgCover": "style-module-scss-module__Hh9fqa__bgCover",
  "bgLayer": "style-module-scss-module__Hh9fqa__bgLayer",
  "bottomLeft": "style-module-scss-module__Hh9fqa__bottomLeft",
  "bottomRight": "style-module-scss-module__Hh9fqa__bottomRight",
  "caseStudies": "style-module-scss-module__Hh9fqa__caseStudies",
  "close": "style-module-scss-module__Hh9fqa__close",
  "ctaButton": "style-module-scss-module__Hh9fqa__ctaButton",
  "emailCopy": "style-module-scss-module__Hh9fqa__emailCopy",
  "isReady": "style-module-scss-module__Hh9fqa__isReady",
  "left": "style-module-scss-module__Hh9fqa__left",
  "longText": "style-module-scss-module__Hh9fqa__longText",
  "metaText": "style-module-scss-module__Hh9fqa__metaText",
  "mobileFooter": "style-module-scss-module__Hh9fqa__mobileFooter",
  "modalInner": "style-module-scss-module__Hh9fqa__modalInner",
  "modalWrapper": "style-module-scss-module__Hh9fqa__modalWrapper",
  "navLink": "style-module-scss-module__Hh9fqa__navLink",
  "navigation": "style-module-scss-module__Hh9fqa__navigation",
  "right": "style-module-scss-module__Hh9fqa__right",
  "showreelLink": "style-module-scss-module__Hh9fqa__showreelLink",
  "socialLink": "style-module-scss-module__Hh9fqa__socialLink",
  "socials": "style-module-scss-module__Hh9fqa__socials",
});
